import React, { useEffect, useState } from "react";
import EmiCalculator from "./EmiCalculator";
import "./EmiCalculator.css";
import "./EmiButton.css";

const EmiButton = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === "Escape") {
        setOpen(false);
      }
    };

    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, []);

  useEffect(() => {
    if (open) {
      document.body.classList.add("emi-panel-active");
    } else {
      document.body.classList.remove("emi-panel-active");
    }

    return () => {
      document.body.classList.remove("emi-panel-active");
    };
  }, [open]);

  return (
    <>
      <button
        type="button"
        className={`floating-emi-btn ${open ? "active" : ""}`}
        onClick={() => setOpen((currentState) => !currentState)}
        aria-label={open ? "Close EMI calculator" : "Open EMI calculator"}
        aria-expanded={open}
        aria-controls="emi-calculator-panel"
      >
        <span className="floating-emi-icon">
          <i className="bi bi-calculator"></i>
        </span>

        <span className="floating-emi-text">
          Calculate EMI
        </span>
      </button>

      <button
        type="button"
        className={`emi-panel-backdrop ${open ? "show" : ""}`}
        onClick={() => setOpen(false)}
        aria-label="Close EMI calculator"
        tabIndex={open ? 0 : -1}
      />

      <aside
        id="emi-calculator-panel"
        className={`emi-panel ${open ? "open" : ""}`}
        aria-hidden={!open}
        aria-label="EMI Calculator"
      >
        <div className="emi-panel-decoration emi-decoration-one"></div>
        <div className="emi-panel-decoration emi-decoration-two"></div>

        <div className="emi-panel-header">
          <div className="emi-panel-heading">
            <span className="emi-panel-heading-icon">
              <i className="bi bi-calculator-fill"></i>
            </span>

            <div>
              <span className="emi-panel-label">
                Financial Planning
              </span>

              <h2>EMI Calculator</h2>
            </div>
          </div>

          <button
            type="button"
            className="emi-close-btn"
            onClick={() => setOpen(false)}
            aria-label="Close EMI calculator"
          >
            <i className="bi bi-x-lg"></i>
          </button>
        </div>

        <div className="emi-panel-intro">
          <p>
            Estimate your monthly loan payment by entering the loan amount,
            interest rate and tenure.
          </p>
        </div>

        <div className="emi-panel-content">
          <EmiCalculator />
        </div>

        <div className="emi-panel-footer">
          <div>
            <i className="bi bi-shield-check"></i>
            Your calculation remains private
          </div>

          <small>
            Results are indicative and may vary according to lender terms.
          </small>
        </div>
      </aside>
    </>
  );
};

export default EmiButton;